<template>
  <svg class="icon-cart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.36 18.09">
    <path class="cls-1" d="M18.36,12.52H7L5,3H20.36Z" />
    <path class="cls-1" d="M1,1H4.6L5,3" />
    <path class="icon-cart__wheels" d="M8.37,18.09a1.84,1.84,0,1,0-1.84-1.84A1.84,1.84,0,0,0,8.37,18.09Z" />
    <path class="icon-cart__wheels" d="M16.9,18.09a1.84,1.84,0,1,0-1.84-1.84A1.84,1.84,0,0,0,16.9,18.09Z" />
  </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.icon-cart {
  display: block;
  fill: transparent;
  stroke-width: 2px;
  stroke: var(--theme-icon-cart-color);
  margin-left: -1px;
  width: 100%;
  pointer-events: none;
  &__wheels {
    stroke: transparent;
    fill: var(--theme-icon-cart-color);
    pointer-events: none;
  }
}
</style>
